module.exports = __webpack_public_path__ + "static/media/logo.f77f9f48.svg";